<template>
  <div class="can-pedalsure hp-block-container">
    <h2 class="hp-block-title">What does mountain bike insurance cover?</h2>
    <div class="hp-prose">
      <p>
        Mountain biking is one of the most accessible forms of cycling. Fast,
        fun and with plenty of skills to learn, there’s nothing quite like
        exploring the trails and grinding dust on an MTB.
      </p>
      <p>
        Of course, to get the absolute maximum out of your MTB riding, you’ll
        need specialist, quality mountain bike insurance.
      </p>
    </div>
    <div class="element-container hp-cards">
      <div>
        <b>Theft</b>: You’ll be fully covered if your mountain bike gets
        pinched, whether at home or out on the trails.
      </div>
      <div>
        <b>Damage</b>: We’ll cover the repair costs if you’ve accidentally
        damaged your MTB, or it gets vandalised.
      </div>
      <div>
        <b>Personal injury</b>: Tried to send it on a run that was just a little
        bit too technical? We’ve all been there, and we can cover you.
      </div>
      <div>
        <b>Public liability</b>: If someone else gets injured or their property
        damaged, we’ll take care of it.
      </div>
      <div>
        <b>Overseas travel</b>: Heading for your mountain bike’s natural
        environment for some R&R? We cover MTB holidays, including transit.
      </div>
      <div>
        <b>Loss of earnings</b>: If you’re injured and can’t work, we’ll support
        you with a weekly payment.
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.can-pedalsure {
  border-top: 1px solid $ps-border;
  border-bottom: 1px solid $ps-border;
}

.title {
  text-align: center;
  font-family: $family-regular;
  margin: 20px 0 0 0;
  font-size: 1.6rem;
  @include tablet {
    margin: 50px 0;
    font-size: 2.5rem;
  }
}
.subtitle {
  color: $ps-gray;
  line-height: 2rem;
}
</style>
